import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './EditRideFare.css';
import getRideFareQuery from './getRideFare.graphql';
import getRideFareOptionsQuery from './getRideFareOptions.graphql';
import RideFareForm from '../../../../components/SiteAdmin/RideFare/RideFareForm';
import Loader from '../../../../components/Common/Loader/Loader';
import messages from '../../../../locale/messages';

class EditRideFare extends React.Component {
  static defaultProps = {
    rideFare: {
      loading: true
    },
    fareOptions: {
      loading: true
    }
  };

  buildInitialValues(fare) {
    const surgePricing = (fare.surgePricing || []).map(item => ({
      id: item.id,
      pricingType: Number(item.pricingType),
      dayPricingValue: item.dayPricingValue,
      datePricingValue: item.datePricingValue,
      startTime: item.startTime,
      endTime: item.endTime,
      surgeValue: item.surgeValue,
      isEnable: item.isEnable
    }));

    return {
      id: fare.id,
      locationId: fare.locationId,
      categoryId: fare.categoryId,
      currency: fare.currency,
      basePrice: fare.basePrice,
      unitPrice: fare.unitPrice,
      minutePrice: fare.minutePrice,
      baseFare: fare.baseFare,
      waitingPrice: fare.waitingPrice,
      riderFeeValue: fare.riderFeeValue,
      driverFeeValue: fare.driverFeeValue,
      isActive: fare.isActive,
      isSurgePrice: fare.isSurgePrice,
      surgePricing
    };
  }

  render() {
    const { id, rideFare, fareOptions } = this.props;
    const loading = rideFare.loading || fareOptions.loading;
    const fare = rideFare.getRideFare && rideFare.getRideFare.result;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={cx(s.heading, 'textAlignRightRTL')}>
              <FormattedMessage {...messages.editRideFare} />
            </div>
            <div className={s.paddingRoutesSection}>
              {
                !loading && fare && <RideFareForm
                  id={id}
                  locations={fareOptions.getLocations}
                  categories={fareOptions.getActiveRideCategories && fareOptions.getActiveRideCategories.results}
                  initialValues={this.buildInitialValues(fare)}
                />
              }
              {
                !loading && !fare && <div className={cx(s.heading, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.noResult} />
                </div>
              }
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getRideFareQuery, {
    name: 'rideFare',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        id: props.id
      }
    })
  }),
  graphql(getRideFareOptionsQuery, {
    name: 'fareOptions',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  })
)(EditRideFare);
